import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useField } from 'formik';
import { FormControl, FormHelperText, FormErrorMessage, Flex } from '@chakra-ui/react';
import { Label } from './label.js';
import { getField } from '../utils/get-field.js';
import { Layout } from '../../Layout/component.js';
import { Icon } from '../../Icon/component.js';
var _excluded = ["helpText", "name", "displayValidationErrors", "labelTooltip", "value", "type"];
var CoreField = function CoreField(_ref) {
  var field = _ref.field,
    errors = _ref.errors,
    touched = _ref.touched,
    changeHandler = _ref.changeHandler;
  var helpText = field.helpText,
    name = field.name,
    displayValidationErrors = field.displayValidationErrors,
    labelTooltip = field.labelTooltip;
  field.value;
  var type = field.type,
    rest = _objectWithoutProperties(field, _excluded);
  var _useField = useField({
      name: name
    }),
    _useField2 = _slicedToArray(_useField, 1),
    formikField = _useField2[0];
  var Field = getField(field.type);
  var choices = ['checkbox', 'radio', 'switch'];
  return /*#__PURE__*/React.createElement(FormControl, {
    key: "field-".concat(name),
    isInvalid: !!errors[field.name] && touched[field.name],
    isRequired: field.required
  }, /*#__PURE__*/React.createElement(Layout, {
    mb: 4
  }, /*#__PURE__*/React.createElement(Label, {
    label: rest.label,
    tooltip: labelTooltip,
    asLegend: typeof field.type === 'string' && choices.includes(field.type)
  }), (helpText === null || helpText === void 0 ? void 0 : helpText.position) === 'top' ? /*#__PURE__*/React.createElement(FormHelperText, null, helpText === null || helpText === void 0 ? void 0 : helpText.text) : null, /*#__PURE__*/React.createElement(Field, _extends({}, formikField, rest, {
    type: type,
    changeHandler: changeHandler
  })), (helpText === null || helpText === void 0 ? void 0 : helpText.position) === 'bottom' ? /*#__PURE__*/React.createElement(FormHelperText, null, helpText === null || helpText === void 0 ? void 0 : helpText.text) : null, displayValidationErrors === false ? null : /*#__PURE__*/React.createElement(FormErrorMessage, null, /*#__PURE__*/React.createElement(Flex, {
    marginRight: "4px"
  }, /*#__PURE__*/React.createElement(Icon, {
    iconName: "octagon-exclamation",
    prefix: "fas"
  })), errors[field.name])));
};
CoreField.displayName = "CoreField";
export { CoreField };